// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/spiral-dive.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/spiral-dive/spiral-dive.js';

mount([g0]);
